import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {makeGetReferencedRecipient} from '../../../../../srcCommon/inboxes/viewer/activity/comment/commentViewerSelectors';
import {
  AnnotationCommentHighlightModel,
  AnnotationMessageHighlightModel,
} from '../../../../models/api/annotationModel';
import {AppState} from '../../../../store/appState';
import {getActivities} from '../../../../store/data/dataSelectors';
import {CommentComposerAnnotationPreview} from './commentComposerAnnotationPreview';

/*
 * Props.
 */

interface CommentComposerAnnotationPreviewContainerPublicProps {
  annotation: AnnotationMessageHighlightModel | AnnotationCommentHighlightModel;
  referencedActivityId: number;
}

/*
 * Selectors.
 */

function getReferencedActivityId(
  _state: AppState,
  props: CommentComposerAnnotationPreviewContainerPublicProps,
) {
  return props.referencedActivityId;
}

function makeGetReferencedActivity() {
  return createSelector(
    [getReferencedActivityId, getActivities],
    (activityId, activities) => activities[activityId],
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CommentComposerAnnotationPreviewContainerPublicProps>()(() => {
  const getReferencedActivity = makeGetReferencedActivity();

  return {
    referencedRecipient: makeGetReferencedRecipient(getReferencedActivity),
  };
});

export const CommentComposerAnnotationPreviewContainer = connect(mapStateToProps)(
  CommentComposerAnnotationPreview,
);
